/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { useAuth } from "cms/auth/hooks/useAuth";
import { SimpliCitySDK } from "cms/sdk";

const ImageLinkItem = (props) => {

    const { item } = props || {};
    const { image: image_guid, link: link_guid } = item || {};

    const { token } = useAuth();
    const [image, setImage] = useState();
    const [link, setLink] = useState();

    useEffect(() => {
        const fetchData = async () => {
            if (!image) {
                if (image_guid) {
                    const img = await SimpliCitySDK.image.findOne(token, image_guid);
                    setImage(img);
                }
            }
        };
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            if (!link) {
                if (link_guid) {
                    const _link = await SimpliCitySDK.link.findOne(token, link_guid);
                    setLink(_link);
                }
            }
        };
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {image &&
                <a
                    className='simplicity-image-link-item'
                    href={link?.url}
                    rel='noopener noreferrer'
                    target='_blank'
                >
                    <img src={image?.url} alt={image?.alt || "image-link"} />
                </a>
            }
        </>
    );
};

ImageLinkItem.displayName = "ImageLinkItem";
export { ImageLinkItem };
